import script from "./CarefullyChosen.vue?vue&type=script&setup=true&lang=js"
export * from "./CarefullyChosen.vue?vue&type=script&setup=true&lang=js"

import "./CarefullyChosen.vue?vue&type=style&index=0&id=0c9611eb&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c9611eb"]])

export default __exports__